import { types } from 'mobx-state-tree';

export const PriceModel = types.model({
    gte: types.number,
    lte: types.number
});
